import GoogleMapsLoader from 'google-maps';
import isIe from '@/scripts/utils/detect-ie';
import mapStyles from './styles.json';
import './googleMaps.scss';

export default function (el) {
  const {
    key, options, coords, markerImage,
  } = el.dataset;
  const { lat, lng } = JSON.parse(coords);
  GoogleMapsLoader.KEY = key;
  return GoogleMapsLoader.load((google) => {
    const center = new google.maps.LatLng(lat, lng);
    const map = new google.maps.Map(el, {
      center,
      styles: mapStyles,
      ...JSON.parse(options),
    });
    const marker = new google.maps.Marker({
      position: center,
      icon: isIe() ? null : markerImage,
      optimized: false,
      origin: isIe() ? null : new google.maps.Point(16, 16),
    });
    marker.setMap(map);
  });
}



// WEBPACK FOOTER //
// ./components/googleMaps/googleMaps.js